import { render } from "./bots.vue?vue&type=template&id=5a1c945c"
import script from "./bots.vue?vue&type=script&lang=js"
export * from "./bots.vue?vue&type=script&lang=js"

import "./bots.vue?vue&type=style&index=0&id=5a1c945c&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/t3_d_M4E/0/hellmanh/rb-app-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__